import { createSlice } from '@reduxjs/toolkit'

const autocompleteSlice = createSlice({
  name: 'autocomplete',
  initialState: {
    textSuggestion: '',
    currentLine: '',
    isOpen: true,
    isLoading: false,
    mode: 'inline',
    streamType: '',
    sentence: '',
    clause: '',
    nextwordpart: '',
    nextwords: '',
    options: [],
    containerData: {
      indentWidth: 0,
      containerTopOffset: 0,
      linePosition: 0,
      hasTextAfterCursor: false
    },
    dropdownHighlightIndex: null,
    streamParts: [],
    isSuggestionElementExists: false,
    isWriting: false,
  },
  reducers: {
    setTextSuggestion(state, { payload }) {
      state.textSuggestion = payload;
    },
    setOptions(state, { payload }) {
      state.options = payload || [];
    },
    setCurrentLine(state, { payload }) {
      state.currentLine = payload;
    },
    setContainerData(state, { payload }) {
      state.containerData.top = payload.top ?? state.containerData.top;
      state.containerData.left = payload.left ?? state.containerData.left;
      state.containerData.height = payload.height ?? state.containerData.height;
      state.containerData.linePosition = payload.linePosition ?? state.containerData.linePosition;
      state.containerData.hasTextAfterCursor = payload.hasTextAfterCursor ?? state.containerData.hasTextAfterCursor;
    },
    setIsOpen(state, { payload }) {
      state.isOpen = payload;
    },
    setAutoCompleteMode(state, { payload }) {
      state.mode = payload;
    },
    highlightOption(state, { payload }) {
      // Set explicitly the null value, passed from outside
      if (payload === null) {
        state.dropdownHighlightIndex = null;
      } else {
        // Detect the direction
        const direction = payload === 'up' ? -1 : 1;
      
        if (state.dropdownHighlightIndex + direction < 0) {
          state.dropdownHighlightIndex = state.options.length - 1;
        } else if (state.dropdownHighlightIndex + direction >= state.options.length) {
          state.dropdownHighlightIndex = 0;
        } else {
          if (state.dropdownHighlightIndex === null) {
            state.dropdownHighlightIndex = 0;
          } else {
            state.dropdownHighlightIndex += direction;
          }
        }
      }
    },
    setSentence(state, { payload }) {
      state.sentence = payload;
    },
    setClause(state, { payload }) {
      state.clause = payload;
    },
    setNextWordPart(state, { payload }) {
      state.nextwordpart = payload;
    },
    setNextWords(state, { payload }) {
      state.nextwords = payload;
    },
    setIsLoading(state, { payload }) {
      state.isLoading = payload;
    },
    addStreamParts(state, { payload }) {
      state.streamParts.push(payload);
    },
    clearStreamParts(state, { payload }) {
      state.streamParts = [];
    },
    setStreamAsTextSuggestion(state) {
      state.textSuggestion = state.streamParts.join('');
    },
    setNextWordsAsTextSuggestion(state) {
      state.textSuggestion = state.nextwords;
    },
    setStreamType(state, { payload }) {
      state.streamType = payload;
    },
    setIsSuggestionElementExists(state, { payload }) {
      state.isSuggestionElementExists = payload;
    },
    setIsWriting(state, { payload }) {
      state.isWriting = payload;
    }
  }
});

export const {
  setTextSuggestion,
  setCurrentLine,
  setContainerData,
  setIsOpen,
  setAutoCompleteMode,
  setOptions,
  highlightOption,
  setSentence,
  setClause,
  setNextWordPart,
  setNextWords,
  setIsLoading,
  addStreamParts,
  clearStreamParts,
  setStreamAsTextSuggestion,
  setNextWordsAsTextSuggestion,
  setStreamType,
  setNextWordPartAsTextSuggestion,
  setIsSuggestionElementExists,
  setIsWriting,
} = autocompleteSlice.actions;
export const autocompleteReducer = autocompleteSlice.reducer;

export default autocompleteSlice;

export const setAutocompleteData = (data) => (dispatch, getState) => {
  const { items, sentence, clause, isOpen, nextwordpart, nextwords } = data;

  isOpen !== undefined && dispatch(setIsOpen(isOpen));

  dispatch(setTextSuggestion(nextwords));
  dispatch(setSentence(sentence));
  dispatch(setClause(clause));
  dispatch(setOptions(items));
  dispatch(setNextWordPart(nextwordpart));
  dispatch(setNextWords(nextwords));
  dispatch(setTextSuggestion(nextwordpart));
};

export const streamAutocompleFailure = () => (dispatch) => {
  dispatch(setIsLoading(false));
  dispatch(setIsOpen(false));
  dispatch(setNextWordPart(''));
  dispatch(setNextWords(''));
  dispatch(clearStreamParts());
  dispatch(setTextSuggestion(''));
};

export const startStreamAutocomple = () => (dispatch) => {
  dispatch(setIsLoading(true));
  dispatch(setIsOpen(true));
  dispatch(setIsWriting(true));
  dispatch(setNextWordPart(''));
  dispatch(setNextWords(''));
  dispatch(clearStreamParts());
};

export const startStreamAutocompleteSentence = () => (dispatch) => {
  dispatch(startStreamAutocomple())
  dispatch(setStreamType('sentence'));
};

export const startStreamAutocompleteClause = () => (dispatch) => {
  dispatch(startStreamAutocomple());
  dispatch(setStreamType('clause'));
};

export const finishStreamAutocomplete = () => (dispatch) => {
  dispatch(setIsLoading(false));
  dispatch(setIsWriting(false));
  dispatch(setStreamAsTextSuggestion());
};

export const processStreamParts = (streamPart) => (dispatch) => {
  dispatch(setIsLoading(false));
  dispatch(addStreamParts(streamPart));
  dispatch(setStreamAsTextSuggestion())
}